import React from 'react';
import ProfileViewImage from "../../Assets/dashboard/profileview.png";
import ProfileViewStyles from "../MainDashboard/ProfileView.module.css";
import { FaTimes } from 'react-icons/fa';

const ProfileView = ({ setprofileTab }) => {
    return (
        <div className={ProfileViewStyles.ProfileView}>
            <div className={ProfileViewStyles.ProfileViewInner}>
                <div className={ProfileViewStyles.ProfileViewImage}>
                    <img src={ProfileViewImage} alt="ProfileViewImage" />
                </div>
                <div className={ProfileViewStyles.ProfileViewDetails}>
                    <p onClick={() => setprofileTab("profile-inactive")} className={ProfileViewStyles.ProfileViewCancel}><FaTimes /></p>
                    <div className={ProfileViewStyles.ProfileViewDetailsInner}>
                        <div className={ProfileViewStyles.ProfileViewAddress}>
                            <p className={ProfileViewStyles.ProfileViewHead}>Hanifa Owuri</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Business owner</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Lagos, Nigeria.</p>
                        </div>
                        <div className={ProfileViewStyles.ProfileViewBio}>
                            <p className={ProfileViewStyles.ProfileViewHead}>Bio.</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>I want to love you and spend money on you.just connect </p>
                        </div>
                        <div className={ProfileViewStyles.ProfileViewOtherDet}>
                            <p className={ProfileViewStyles.ProfileViewHead}>About</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Religion: Christian</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Political affiliation: APC</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Exercise: dont workout</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Kids: No kids</p>
                            <p className={ProfileViewStyles.ProfileViewBody}>Alcohol: dont drink</p>
                        </div>
                    </div>
                </div>
            </div>
            <p className={ProfileViewStyles.block}>Block & Report</p>
        </div>
    )
}

export default ProfileView
